/**
 * The base vocabulary (S36, Martin 01.11.2026) from household-kit (lang; geprüfte Kopie in
 * packages/shared/lang): common short words of German menus in every language of the card – sections,
 * categories, courses, labels of prices and portions, the drinks' words, the additives 1–14 (not set by
 * the EU, unlike the 14 allergens). Changed there, never here.
 *
 * Rules (Martin): the business's own translation always wins, also when it reads the same. The base is
 * never copied into a business's dictionary but looked up each time, so a correction holds with the
 * next copy wherever the field still showed the base.
 */
import { phraseOf as kitPhraseOf } from "@household-kit/lang";
import type { BasePhrase } from "@household-kit/lang";
import type { Lang } from "./translation.ts";
import type { Phrase, Phrases } from "./phrases.ts";

export { BASE_PHRASES, phraseKey } from "@household-kit/lang";

/** A translation found: the business's own, else the base vocabulary's (`by: "base"`). */
export type FoundPhrase = Phrase | BasePhrase;

/** A text's translation into the language: the business's own always first, then the base. */
export const phraseOf = (text: string, lang: Lang, phrases: Phrases): FoundPhrase | undefined => kitPhraseOf(text, lang, phrases);
